<template>
  <tr class="table-analytics__data">
            <td data-cell="фото">
              <AvatarContainer :src="data.avatarLink ? apiUrl + 'static/' + data.avatarLink : require('@/assets/student_photo_placeholder.svg')" class="flex justify-center" :small="true"  />
            </td>
            <td data-cell="Тренер">{{data.coachsName}}</td>
            <td data-cell="Груп"><span class="text-[14px]">
              {{data.numberOfGroups}}
            </span>
            </td>
            <td data-cell="Гравців">{{data.numberOfPlayers}}</td>
            <td data-cell="Динаміка к-ті проведених тренувань">
              <div ref="chartContainer" style="width: 90%; height: 90px;"></div>
            </td>
            <td data-cell="Останні матчі">
              <div class="flex gap-[8px] justify-center">
                <div 
                  v-if="data.lastMatches.length"
                  v-for="match in data.lastMatches" 
                  class="w-[25px] h-[25px] text-[10px] flex items-center justify-center font-bold"
                  :class="{
                    'bg-[#21A179] text-white': match.result == 'W',
                    'bg-[#F61067] text-white': match.result == 'L',
                    'bg-[#C6F100] text-[#0E1420]': match.result == 'D'
                  }"  
                >{{ match.score }}</div>
                <div v-else class="text-white text-[10px]">Немає матчів</div>
              </div>
            </td>
          </tr>
</template>

<script>
import {onMounted, onUnmounted, ref, toRefs, watchEffect} from 'vue';
import * as echarts from "echarts";

export default {
  name: "AnalyticsComponentElement",
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  setup(props) {
    const { data } = toRefs(props);
    const chartContainer = ref(null);
    const barCharContainer = ref(null);
    let myBarChart;
    let myChart;

    const apiUrl = process.env.VUE_APP_API_URL;

    watchEffect(()=>{
      if (!barCharContainer.value) return;
      if (!myBarChart) {
        myBarChart = echarts.init(barCharContainer.value, "transparent", {renderer: "svg"});
      }
      const optionBar = {
        color: ["#C6F100"],
        xAxis: {
          type: 'category',
          show: false,
        },
        yAxis: {
          type: 'value',
          show: false,
        },
        legend: {
          show: false
        },
        series: [
          {
            name: "Сальдо",
            data: data.value.totalPerYear,
            type: 'bar',
            label: {
              show: true,
              fontSize:14,
              position: 'top',
              color: "#C6F100"
            },
          }
        ]
      };
      myBarChart.setOption(optionBar, true);

    })
    watchEffect(() => {
      if (!chartContainer.value) return;
      if (!myChart) {
        myChart = echarts.init(chartContainer.value, "transparent", {renderer: "svg"});
      }
      const option = {
        color: ["#C6F100"],
        xAxis: {
          type: 'category',
          show: false,
        },
        yAxis: {
          type: 'value',
          show: false,
        },
        legend: {
          show: false
        },
        series: [
          {
            name: "Сальдо",

            data: data.value.trainingsPerYear,
            type: 'line',
            symbol: "circle",
            barWidth: '60%',
            symbolSize: 0,
            label: {
              show: true,
              fontSize:10,
              position: 'top',
              color: "#C6F100"
            },
            lineStyle: {
              width: 2
            }
          }
        ]
      };


      myChart.setOption(option, true);
    });

    onMounted(() => {
      if (!chartContainer.value||!barCharContainer.value) return;
    });
    const updateChartSize = () => {
      if(myChart)myChart.resize();
      if(myBarChart)myBarChart.resize();
    };
    onMounted(() => {
      window.addEventListener('resize', updateChartSize);
      console.log(data.value);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', updateChartSize);
        // myChart.dispose(); // Очищуємо графік при знищенні компонента
        // myBarChart.dispose(); // Очищуємо графік при знищенні компонента
    });

    return { chartContainer,barCharContainer, apiUrl};
  }
};
</script>

